<template>
  <div class="home row">
    <div class="col-8">
      <transition name="slide-fade">
        <h1 v-if="showTitle">{{msg}}</h1>
      </transition>
      <el-alert class="mt-3" :title="desc" type="info" :closable="false"></el-alert>
      <el-form
        ref="form"
        :inline="true"
        class="mt-3"
        @submit.native.prevent
        v-loading="loadingAdFrecuency"
      >
        <el-form-item label="Configurar el número máximo de items">
          <el-input-number size="medium" v-model="maxMenuItems" :min="1"></el-input-number>
          <el-button
            class="ml-3"
            type="info"
            @click="patchHomeConfig('MAX_MENU_ITEMS', maxMenuItems)"
          >Guardar</el-button>
        </el-form-item>
      </el-form>
      <h2>Menú home
        <el-button size="mini" type="info" plain circle class="button" @click="createMenuItem()">
          <i class="fas fa-plus"></i>
        </el-button>
      </h2>
      <ul class="list-unstyled d-flex">
        <li
          class="media w-50"
          :class="{'ml-3': index % menuItems.length !== 0}"
          v-for="(item, index) in menuItems"
          :key="item.id"
        >
          <img :src="item.img" class="mr-3 w-25" :alt="item.title">
          <div class="media-body">
            <h5 class="mt-0 mb-1">{{item.title}}</h5>
            <p class="mb-1">
              <i class="fas fa-link"></i>
              <a :href="item.url" target="_blank" class="ml-1 text-dark">Enlace</a>
            </p>
            <div class="d-flex justify-content-between align-items-center">
              <el-switch
                class
                :value="item.published"
                active-color="#31022a"
                @change="toggleMenuPublished(item.id, item.published)"
              ></el-switch>
              <div>
                <el-button
                  size="mini"
                  type="danger"
                  plain
                  circle
                  class="button"
                  @click="deleteMenuItem(item.id)"
                >
                  <i class="fas fa-trash-alt"></i>
                </el-button>
                <el-button
                  size="mini"
                  type="info"
                  plain
                  circle
                  class="button"
                  @click="editMenuItem(item.id)"
                >
                  <i class="fas fa-pencil-alt"></i>
                </el-button>
              </div>
            </div>
          </div>
        </li>
      </ul>

      <el-dialog
        id="menu-item-modal"
        class="modal-medium"
        :title="menuItemModalTitle"
        :visible.sync="menuItemModal"
        width="360px"
        top="28px"
        :append-to-body="true"
        :before-close="handleClose"
      >
        <div class v-loading="loadingMenuItem" element-loading-text="Cargando item">
          <div class="position-relative">
            <div id="cropper-item-img" class="avatar">
              <img :src="menuItem.img" class="bg-white card-img-top rounded-0">
            </div>
            <div class="group-avatar">
              <avatar-cropper
                ref="cropperImg"
                :upload-handler="cropperItemImgHandler"
                trigger="#cropper-item-img"
                :mimes="cropperAllowedInputMimes"
                :output-mime="cropperOutputMime"
                :output-quality="0.9"
                :cropper-options="cropperItemImgOptions"
                :output-options="cropperItemImgOutputOptions"
                :labels="cropperLabels"
              />
            </div>
            <div class="mt-3">
              <h2
                class="line-height-1 mb-0 text-dark"
                contenteditable
                @keydown.enter.prevent
                @blur="menuItem.title = $event.target.textContent"
              >{{menuItem.title}}</h2>
              <p class="mb-0 text-dark">
                <i class="fas fa-link"></i>
                <span
                  class="ml-1"
                  contenteditable
                  @keydown.enter.prevent
                  @blur="menuItem.url = $event.target.textContent"
                >{{menuItem.url}}</span>
              </p>
              <p
                class="mb-0 text-muted"
                contenteditable
                @keydown.enter.prevent
                @blur="menuItem.description = $event.target.textContent"
              >{{menuItem.description}}</p>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="saveMenuItem()">Guardar</el-button>
        </span>
      </el-dialog>
    </div>
    <div class="col-4">
      <div id="cropper-img">
        <img class="img-fluid" :src="homeImg" :v-loading="loadingHomeConfig">
      </div>
      <avatar-cropper
        ref="cropperImg"
        :upload-handler="cropperImgHandler"
        trigger="#cropper-img"
        :mimes="cropperAllowedInputMimes"
        :output-mime="cropperOutputMime"
        :output-quality="0.9"
        :cropper-options="cropperImgOptions"
        :output-options="cropperImgOutputOptions"
        :labels="cropperLabels"
        @changed="cropperImgChanged"
      />
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { APIENDPOINT } from "@/backend";

import AvatarCropper from "vue-avatar-cropper";

export default {
  name: "Home",

  components: {
    AvatarCropper
  },

  data() {
    return {
      showTitle: false,
      msg: "Bienvenido",
      desc:
        "Está usted en el panel de administración para la aplicación de la CEE",
      loadingHomeConfig: false,
      loadingMenuItem: false,
      homeConfig: [],
      maxMenuItemsInput: "",
      cropperAllowedInputMimes: "image/png, image/jpeg, image/webp",
      cropperOutputMime: "image/webp",
      cropperLabels: {
        cancel: "Cancelar",
        submit: "Enviar"
      },
      cropperImgOptions: {
        aspectRatio: 0.5625, // 9x16 landscape
        autoCropArea: 1,
        viewMode: 1,
        movable: false,
        zoomable: false
      },
      cropperImgOutputOptions: {
        width: 900,
        height: 1600,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: "low"
      },
      cropperItemImgOptions: {
        aspectRatio: 1, // square
        autoCropArea: 1,
        viewMode: 1,
        movable: false,
        zoomable: false
      },
      cropperItemImgOutputOptions: {
        width: 256,
        height: 256,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: "low"
      },
      homeImg: require("@/assets/images/placeholder-1080x1920.png"),
      maxMenuItems: 2,
      menuItems: "",
      menuItemModalTitle: "",
      menuItemModal: false,
      menuItem: {},
      menuItemImgModified: false
    };
  },

  mounted() {
    this.showTitle = true;
    this.getHomeConfig();
    this.getMenuItems();
  },

  methods: {
    getHomeConfig() {
      this.loadingHomeConfig = true;
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "get",
        url: "/api/v1/home-config"
      })
        .then(response => {
          if (response.data.code === 0) {
            this.homeConfig = response.data.data.homeConfig;
            this.homeImg = this.homeConfig.find(
              item => item.type === "HOME_IMG"
            ).value;
            this.maxMenuItems = this.homeConfig.find(
              item => item.type === "MAX_MENU_ITEMS"
            ).value;
            // console.group("homeConfig:");
            // console.log(this.homeConfig);
            // console.groupEnd();
          }
        })
        .catch(error => {
          this.$notify.error({
            title: "Error",
            message: error
          });
        })
        .finally(() => (this.loadingHomeConfig = false));
    },

    patchHomeConfig(type, value) {
      // console.log(type, value);
      this.loadingHomeConfig = true;

      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "patch",
        url: "/api/v1/home-config",
        data: { type: type, value: value }
      })
        .then(response => {
          console.group("patchHomeConfig:");
          console.log(response);
          console.groupEnd();
          this.loadingHomeConfig = false;
          this.getHomeConfig();
        })
        .catch(error => {
          this.$notify.error({
            title: "Error",
            message: error
          });
        });
    },

    getMenuItems() {
      this.loadingMenuItems = true;

      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "get",
        url: "/api/v1/menu-items"
      })
        .then(response => {
          this.loadingMenuItems = false;
          if (response.data.code === 0) {
            this.menuItems = response.data.data.menuItems;
            // console.group("menuItems:");
            // console.log(this.menuItems);
            // console.groupEnd();
          }
        })
        .catch(error => {
          this.$notify.error({
            title: "Error",
            message: error
          });
        });
    },

    createMenuItem() {
      this.menuItemModalTitle = `Crear item de menú`;
      this.menuItem = {
        id: null,
        title: "Título",
        description: "descripción",
        url: "www",
        img: require("@/assets/images/placeholder-256x256.png")
      };
      this.menuItemModal = true;
    },

    editMenuItem(id) {
      // console.log(id);
      this.menuItem = this.menuItems.find(item => item.id === id);
      this.menuItemModalTitle = `Editar item de menú ID ${id}`;
      this.menuItemModal = true;
    },

    setMenuItemTitle(e) {
      this.menuItem.title = e.target.textContent;
    },

    saveMenuItem() {
      this.loadingMenuItem = true;
      let axiosURL = "/api/v1/menu-items/";
      let axiosMethod = "post";
      if (this.menuItem.id !== null) {
        axiosURL = axiosURL + this.menuItem.id;
        axiosMethod = "patch";
      }
      let axiosData = {
        title: this.menuItem.title,
        description: this.menuItem.description,
        url: this.menuItem.url,
        published: this.menuItem.published
      };

      if (this.menuItemImgModified) {
        axiosData.img = this.menuItem.img;
      }

      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: axiosMethod,
        url: axiosURL,
        data: axiosData
      })
        .then(response => {
          // console.log(axiosData, response);
          this.getMenuItems();
          this.loadingMenuItem = false;
          this.menuItemModal = false;
          if (response.data.code !== 0) {
            this.$message({
              showClose: false,
              message: response.data.description,
              type: "warning",
              duration: 4500
            });
          }
        })
        .catch(error => {
          this.$notify.error({
            title: "Error",
            message: error
          });
        })
        .finally(() => {
          this.loadingMenuItem = false;
          this.menuItemModal = false;
          this.menuItemImgModified = false;
        });
    },

    deleteMenuItem(id) {
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "delete",
        url: "/api/v1/menu-items/" + id
      })
        .then(response => {
          console.log(response);
          this.getMenuItems();
          if (response.data.code !== 0) {
            this.$message({
              showClose: false,
              message: response.data.description,
              type: "warning",
              duration: 4500
            });
          }
        })
        .catch(error => {
          this.$notify.error({
            title: "Error",
            message: error
          });
        });
    },

    toggleMenuPublished(id, published) {
      // console.log(id, published);
      axios({
        baseURL: APIENDPOINT,
        headers: {
          Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("token")).access_token
        },
        method: "patch",
        url: "/api/v1/menu-items/" + id,
        data: {
          published: !published
        }
      })
        .then(response => {
          console.log(response);
          this.getMenuItems();
          if (response.data.code !== 0) {
            this.$message({
              showClose: false,
              message: response.data.description,
              type: "warning",
              duration: 4500
            });
          }
        })
        .catch(error => {
          this.$notify.error({
            title: "Error",
            message: error
          });
        });
    },

    cropperImgChanged(file, reader) {
      var that = this;
      reader.addEventListener("load", function() {
        var image = new Image();
        image.src = reader.result;
        image.onload = () => {
          if (
            image.width < that.cropperImgOutputOptions.width ||
            image.height < that.cropperImgOutputOptions.height
          ) {
            // console.log(reader)
            if (that.$refs.cropperImg !== undefined)
              that.$refs.cropperImg.destroy();
            that.$message({
              showClose: false,
              message:
                "Se espera un ancho y alto mínimo de " +
                that.cropperImgOutputOptions.width +
                "x" +
                that.cropperImgOutputOptions.height +
                "px.",
              type: "warning",
              duration: 4500
            });
          }
        };
      });
    },

    cropperImgHandler(cropper) {
      // console.group("cropperHandler");
      // console.log(cropper.getCroppedCanvas().toDataURL(this.cropperOutputMime));
      // console.groupEnd();
      let homeImg = cropper
        .getCroppedCanvas(this.cropperImgOutputOptions)
        .toDataURL(this.cropperOutputMime);
      this.patchHomeConfig("HOME_IMG", homeImg);
    },

    cropperItemImgHandler(cropper) {
      // console.group("cropperHandler");
      // console.log(cropper.getCroppedCanvas().toDataURL(this.cropperOutputMime));
      // console.groupEnd();
      this.menuItem.img = cropper
        .getCroppedCanvas(this.cropperItemImgOutputOptions)
        .toDataURL(this.cropperOutputMime);
      this.menuItemImgModified = true;
    }
  }
};
</script>

<style lang="scss">
.menu-items .el-card .absolute {
  top: 0;
}

.menu-items .el-card .el-button {
  opacity: 0;
}

.menu-items .el-card:hover .el-button {
  opacity: 1;
}

.el-card img {
  max-width: 100%;
  height: auto;
}

#menu-item-modal .el-dialog__body {
  padding: 0 20px;
}
</style>
